import React from 'react';
import { FileUpload } from 'fw/forms';
import * as Notifications from 'fw/globals/Notifications'

class DocumentUpload extends React.Component {

	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
		return {
			fileName: this.props.fileName,
			storageToken: this.props.storageToken,
		};
	}

	componentDidMount() {
		if (this.state.storageToken === undefined || this.state.storageToken === null)
			return;
		this.initFile(this.state.fileName, this.state.storageToken);
	}

	componentWillReceiveProps(props) {
		this.initFile(props.fileName, props.storageToken);

		this.setState({
			fileName: props.fileName,
			storageToken: props.storageToken
		});
	}

	initFile = (fileName, storageToken) => {
		let files = [];

		if (storageToken === undefined || storageToken === null)
			return;

		files.push({
			storageToken: storageToken,
			fileName: fileName,
			uploaded: true,
			uploading: false,
			error: false,
		});

		this._fileBox.uploadFile(files);
	}

	blankFile = (i) => {
		this._fileBox._remove(i);

	}

	handleRemove = () => {
		this.props.onRemove && this.props.onRemove();		
	}

	handleChange = (files) => {
		var file = {
			fileName: null,
			storageToken: null
		};

		if (files && files[0]) {
			file = {
				fileName: files[0].fileName,
				storageToken: files[0].storageToken
			}
		}

		this.setState(() => {
			return {
				file
			}
		}, () => {
			this.props.onChange(file);
		});
	}

	handleError = (error) => {
		Notifications.error(error);
	}

	render() {
		return (
			<FileUpload
				accept=".pdf, .png, .jpg, .doc, .docx, .xls, .xlsx, .txt, .mp4"
				onChange={this.handleChange}
				ref={(f) => this._fileBox = f}
				maxBytes={300000000}
				onRemove={this.handleRemove}
				onError={this.handleError}
				disabled={this.props.disabled}
				skipConfirmation={this.props.skipConfirmation}
				confirmationMsg={this.props.confirmationMsg}
				placeholder={this.props.placeholder}
				wrapFileNameLength={this.props.wrapFileNameLength}
				useEncryption={this.props.useEncryption}
				folder={this.props.folder}
			/>

		)
	}
}

export default DocumentUpload;

// Mark this as a form component
DocumentUpload.defaultProps = {
	formControl: true,
	managed: false,
	wrapFileNameLength: 50,
	useEncryption: false
};




// WEBPACK FOOTER //
// ./src/areas/shared/controls/documentUpload/DocumentUpload.js